function showToast({ type = 'success', message = '', duration = 5000 }) {
  const toastContainer = document.getElementById('global-toast-container');
  if (!toastContainer) return;

  // Set up initial content and class
  toastContainer.innerHTML = `
    <span class="banner__ribbon">${globalIcons[type]}</span>
    <p class="banner__content" >${message}</p>
  `;
  toastContainer.className = `banner banner--${type} toast-enter`;
  toastContainer.style.display = 'flex';

  // Timeout handling
  if (toastContainer.toastTimeout) {
    clearTimeout(toastContainer.toastTimeout);
  }

  toastContainer.toastTimeout = setTimeout(() => {
    toastContainer.classList.remove('toast-enter');
    toastContainer.classList.add('toast-exit');

    setTimeout(() => {
      toastContainer.style.display = 'none';
      toastContainer.classList.remove('toast-exit');
    }, 400); // match with animation duration
  }, duration);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////

let isLoadingTreatments = false;
let treatmentsData = null;
let treatmentsPromise = null;

const fetchAllTreatments = async () => {
  if (treatmentsData) return treatmentsData;
  if (treatmentsPromise) return treatmentsPromise;

  isLoadingTreatments = true;

  treatmentsPromise = callAPI({
    endpoint: `/treatments/plattform-get-treatments?pageType=all&pageId=all`,
  })
    .then((res) => {
      treatmentsData = res.data;
      return treatmentsData;
    })
    .finally(() => {
      isLoadingTreatments = false;
      treatmentsPromise = null;
    });

  return treatmentsPromise;
};

const getAllTreatments = async () => {
  if (treatmentsData) return treatmentsData;
  return await fetchAllTreatments();
};

// ✅ Kapseln in einem Objekt
window.treatmentsQuery = {
  getAll: getAllTreatments,
  isLoading:  () => isLoadingTreatments,
  hasFetched: () => treatmentsData !== null,
};

// Optional: direkt einmalig triggern
window.treatmentsQuery.getAll();

////////////////////////////////////////////////////////////////////////////////////////////////////


let isLoadingPhysioTreatments = false;
let physioTreatmentsData = null;
let physioTreatmentsPromise = null;

const fetchAllPhysioTreatments = async () => {
  if (physioTreatmentsData) return physioTreatmentsData;
  if (physioTreatmentsPromise) return physioTreatmentsPromise;

  isLoadingPhysioTreatments = true;

  physioTreatmentsPromise = callAPI({
    endpoint: `/physio-treatments/plattform-get-physio-treatments`,
  })
    .then((res) => {
      physioTreatmentsData = res.data;
      return physioTreatmentsData;
    })
    .finally(() => {
      isLoadingPhysioTreatments = false;
      physioTreatmentsPromise = null;
    });

  return physioTreatmentsPromise;
};

const getAllPhysioTreatments = async () => {
  if (physioTreatmentsData) return physioTreatmentsData;
  return await fetchAllPhysioTreatments();
};

// ✅ Kapseln in einem Objekt
window.physioTreatmentsQuery = {
  getAll: getAllPhysioTreatments,
  isLoading:  () => isLoadingPhysioTreatments,
  hasFetched: () => physioTreatmentsData !== null,
};

// Optional: direkt einmalig triggern
window.physioTreatmentsQuery.getAll();

//////////////////////////////////////////////////////////////////////////////////////////////////////



const getShopifyHandle = (productTitle) => {
    if(productTitle === "Endolaser Lifting") {
      return "endolift-laserlifting"
    }
    return productTitle
        .toLowerCase() // Kleinbuchstaben
        .replace(/ä/g, 'ae') // Umlaute ersetzen
        .replace(/ö/g, 'oe')
        .replace(/ü/g, 'ue')
        .normalize("NFD") // Zerlegt Akzentbuchstaben in Basisbuchstabe + diakritische Zeichen
        .replace(/[\u0300-\u036f]/g, '') // Entfernt diakritische Zeichen (Akzente)
        .replace(/ß/g, 'ss')
        .replace(/:/g, '-') // ersetzt ":" durch "-"
        .replace(/\bbotox\b/g, 'muskelrelaxanz') // "botox" durch "muskelrelaxanz" ersetzen (nur ganzes Wort)
        .replace(/[^\w\s&-]/g, '') // Sonderzeichen entfernen (lässt "&" zu)
        .replace(/\s+/g, '-') // Leerzeichen durch Bindestrich ersetzen
        .replace(/-+/g, '-') // Doppelte Bindestriche vermeiden
        .replace(/[\(\)\.\/,]/g, '') // Sonderzeichen werden entfernt    
} 

window.getShopifyHandle = getShopifyHandle

const fetchShopifyProduct = async (handleName) => {
  
  const shopifyProductRes = await fetch(`/products/${handleName}.json`)

  if(shopifyProductRes.status === 200) {
    const shopifyProduct = await shopifyProductRes.json()
    if(!shopifyProduct) return null
    return shopifyProduct
    
  } else {
    return null
  }
}

window.fetchShopifyProduct = fetchShopifyProduct

////////////////////////////////////////////////////////////////////////////////////////////////////

window.updateApComponents = (selectedAp) => {
  if(window?.renderGlobalBarApInfos) window.renderGlobalBarApInfos(selectedAp)
  if(window?.runMobileMenuScript) window.runMobileMenuScript()
  if(window?.runDesktopMenuScript) window.runDesktopMenuScript()
  if(window?.runApChangeScript) window.runApChangeScript() 
}

////////////////////////////////////////////////////////////////////////////////////////////////////

window.setLocalStorageItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error("Fehler beim Speichern im localStorage:", error);
  }
};

window.getLocalStorageItem = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error("Fehler beim Laden aus localStorage:", error);
    return null;
  }
};
////////////////////////////////////////////////////////////////////////////////////////////////

window.setSessionStorageItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error("Fehler beim Speichern im sessionStorage:", error);
  }
};

window.getSessionStorageItem = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error("Fehler beim Laden aus sessionStorage:", error);
    return null;
  }
};

////////////////////////////////////////////////////////////////////////////////////////////////

const formatURLPathToString = (urlPath) => {

  const specialCases = {
    "leipzig-alt-west": "Leipzig Alt-West",
  };
  if (specialCases[urlPath]) {
    return specialCases[urlPath];
  }
  
  const umlautMap = {
    ae: "ä",
    oe: "ö",
    ue: "ü",
    ss: "ß",
  };

  // Schritt 1: Bindestriche durch Leerzeichen ersetzen
  let str = urlPath.replace(/-/g, " ");

  // Schritt 2: ae, oe, ue, ss durch Umlaute ersetzen
  Object.entries(umlautMap).forEach(([ascii, umlaut]) => {
    const regex = new RegExp(ascii, "gi");
    str = str.replace(regex, (match) =>
      match === match.toUpperCase()
        ? umlaut.toUpperCase()
        : umlaut
    );
  });

  // Schritt 3: Erste Buchstaben jedes Wortes groß schreiben
  str = str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return str;
};


////////////////////////////////////////////////////////////////////////////////////////////////////

const globalUrlParams = new URLSearchParams(window.location.search);
const globalApToSelect = globalUrlParams.get("campaignname");
const path = window.location.pathname;

if(globalApToSelect && !path.includes('physio')) {
  window.setLocalStorageItem('selected_ap', `Aesthetic Point ${globalApToSelect}`)
}
if(globalApToSelect && path.includes('physio')) {
  window.setLocalStorageItem('selected_physio', `Physio ${globalApToSelect}`)
}

if(path.includes('pages') && path.includes('aesthetic-point') &&  !path.includes('aesthetic-point-treatments')){
  const withoutPages = path.replace(/^\/pages\//, "");
  const withoutAP = withoutPages.replace('aesthetic-point-', "");
  const apPath = withoutAP.split("/")[0]
  window.setLocalStorageItem('selected_ap', `Aesthetic Point ${formatURLPathToString(apPath)}`)
}


if(path.includes('pages') && path.includes('physio')){
  const withoutPages = path.replace(/^\/pages\//, "").replace('/','');
  const withoutAP = withoutPages.replace('physio-', "");
  const apPath = withoutAP.split("/")[0]
  window.setLocalStorageItem('selected_physio', `Physio ${formatURLPathToString(apPath)}`)
}


 
/////////////////////////////////////////////////////////////////////////////////////////////////////

function getOrCreateSessionId() {
  const key = 'session_id';
  const raw = localStorage.getItem(key);
  const now = Date.now();
  const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 Minuten

  let session = null;

  if (raw) {
    try {
      session = JSON.parse(raw);

      // Prüfen, ob die Session abgelaufen ist
      if (now - session.lastActivity > SESSION_TIMEOUT) {
        session = null; // abgelaufen
      }
    } catch (e) {
      // defekter JSON → neue Session erzeugen
      session = null;
    }
  }

  if (!session) {
    session = {
      id: crypto.randomUUID(),    
      lastActivity: now
    };
  } else {
    session.lastActivity = now;    // aktualisieren bei jedem Aufruf
  }

  localStorage.setItem(key, JSON.stringify(session));
  return session.id;
}

window.getOrCreateSessionId = getOrCreateSessionId

/////////////////////////////////////////////////////////////////////////////////////////////////////


/*
window.getGlobalApSelectElement = (componentId) => {
  const globalApSelectWrapperEle = document.createElement('div')

  const handleTreatmentsLoaded = (treatDocs) => {
    globalApSelectWrapperEle.innerHTML = `
      <select
        id="custom-desk-menu-ap-select"
        class="input__field"
        name="aesthetic-point"
        style=" max-width: 288px; text-align: center; border: 1px solid #FFFFFF; display: none"
      >
        <option value="placeholder" style="display: none" disabled selected>- Wähle deinen Aesthetic Point -</option>
        ${treatDocs.map(treatDoc => {
          return `<option key="${treatDoc.user_aesthetic_point}" value="${treatDoc.user_aesthetic_point}">${treatDoc.user_aesthetic_point}</option>`
        })}
      </select>
    `
  } 
  
  let treatments = null;
  let retries = 0;
  const maxRetries = 40; // 40 Versuche = 10 Sekunden
  const tryLoadTreatments = async () => {
    const isLoading = window.treatmentsQuery.isLoading();

    if (!isLoading) {
      const treatments = await window.treatmentsQuery.getAll();
      handleTreatmentsLoaded(treatments);
    } else if (retries < maxRetries) {
      retries++;
      setTimeout(tryLoadTreatments, 250);
    } else {
      console.warn("❌ Max. Wiederholungen erreicht. Daten konnten nicht geladen werden.");
    }
  };
  tryLoadTreatments()
  globalApSelectWrapperEle.innerHTML = 
};
*/
